import { ChatResponder, MessageOwner } from 'types';

export type TranscriptOwnerLabels = {
  agent: string;
  bot: string;
  user: string;
};

type OwnerSource = {
  owner?: string;
  withAgent?: boolean;
};

export function getPdfOwnerNameForTranscript(
  currentMsg: OwnerSource,
  agent: ChatResponder,
  bot: ChatResponder,
  labels: TranscriptOwnerLabels,
): string {
  if (currentMsg.owner === MessageOwner.USER) return labels.user;
  if (currentMsg.withAgent) {
    return agent.withName ? agent.name ?? labels.agent : labels.agent;
  }
  return bot.withName ? bot.name ?? labels.bot : labels.bot;
}
